import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import styles from "./backLink.module.scss";

interface BackLinkProps {
    /** Already-localized destination path - callers resolve `lp()` themselves. */
    to: string;
    /** Already-translated label text. */
    label: string;
    className?: string;
}

// Shared "go back" link used on drill-down pages (kanji/grammar detail,
// blog posts, practice tools) so the markup, icon and styling stay
// consistent instead of being copy-pasted per page.
export default function BackLink({ to, label, className }: BackLinkProps) {
    const linkClassName = className ? `${styles.backLink} ${className}` : styles.backLink;
    return (
        <Link to={to} className={linkClassName}>
            <FontAwesomeIcon icon={faArrowLeft} /> {label}
        </Link>
    );
}
